import React from "react";

export function QuickActionInstructionText() {
  return (
    <h5 className="text-gray-400 dark:text-gray-500 my-2">
      Click the checkbox icons to select one or more notes.
    </h5>
  );
}
